import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {denim, white} from '/theme/color/on.color';
import {alto, darkRed, wineRed} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: white,
    paddingHorizontal: 10,
    width: '98%',
  },
  container: {
    borderColor: alto,
    borderWidth: 1,
    width: '91%',
    borderRadius: 4,
    marginLeft: indent * 1,
  },
  alertButtonIcon: {
    fontSize: 18,
    fontWeight: '700',
    color: wineRed,
    marginRight: indent * 0.8,
  },
  accordionIcon: {
    position: 'absolute',
    right: indent * 0.1,
  },
  accordionBody: {
    paddingTop: indent * 0.1,
    marginLeft: indent * 0.1,
    marginHorizontal: indent * 0.2,
  },
  accordionHeader: {
    backgroundColor: white,
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: indent * 0.5,
  },
  bannerText: {
    width: '70%',
    lineHeight: 21,
  },
  accordionBodyContent: {
    backgroundColor: white,
    flexDirection: 'row',
    marginBottom: indent * 0.3,
    paddingVertical: indent * 0.1,
    marginLeft: indent * 0.1,
  },
  link: {
    color: denim,
    fontWeight: '600',
  },
  textStyle: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  btnStyle: {
    marginBottom: 10,
    marginTop: 20,
  },
  trashIcon: {
    color: wineRed,
    fontSize: 16,
    fontWeight: 500,
    marginLeft: 14,
    marginRight: 4,
  },
  removeLabel: {
    color: darkRed,
    fontSize: 14,
    paddingLeft: indent * 0.1,
  },
});
